import { toDate as s } from "./toDate.js";
import { constructFrom as a } from "./constructFrom.js";
function l(o) {
  const e = s(o), n = e.getFullYear(), r = e.getMonth(), t = a(o, 0);
  return t.setFullYear(n, r + 1, 0), t.setHours(0, 0, 0, 0), t.getDate();
}
export {
  l as default,
  l as getDaysInMonth
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getDaysInMonth.js
// module id = 1343
// module chunks = 41